// Game design data. Stats order: [captain, rightHand, combat, navigation, support, specialist] (0-100).
// "person" groups the same character across eras/groups: one person can be in the crew only once per run.
// "era" is an optional label shown under the name (never the stats).
// Characters are listed by importance/strength (display order only, no effect on randomness).

import { naturalRolesFor, OVERRIDES } from "./naturalRoles";

const ch = (id, name, person, [captain, rightHand, combat, navigation, support, specialist], era = null) => ({
  id,
  name,
  person,
  era,
  stats: { captain, rightHand, combat, navigation, support, specialist, ...OVERRIDES[id] },
});

const RAW_CREWS = [
  {
    id: "straw-hat",
    name: "Pirati di Cappello di Paglia",
    characters: [
      ch("luffy", "Monkey D. Luffy", "luffy", [96, 78, 95, 21, 68, 34]),
      ch("zoro", "Roronoa Zoro", "zoro", [74, 95, 82, 20, 60, 21]),
      ch("sanji", "Sanji", "sanji", [70, 80, 76, 73, 82, 71]),
      ch("jinbe", "Jinbe", "jinbe", [76, 81, 71, 96, 82, 71]),
      ch("robin", "Nico Robin", "robin", [67, 69, 59, 71, 75, 100]),
      ch("franky", "Franky", "franky", [63, 57, 63, 67, 79, 96]),
      ch("brook", "Brook", "brook", [58, 59, 61, 69, 68, 67]),
      ch("nami", "Nami", "nami", [64, 45, 27, 100, 75, 77]),
      ch("usopp", "Usopp", "usopp", [52, 36, 38, 64, 72, 71]),
      ch("chopper", "Tony Tony Chopper", "chopper", [38, 28, 44, 54, 98, 74]),
    ],
  },
  {
    id: "roger",
    name: "Pirati di Roger",
    characters: [
      ch("roger", "Gol D. Roger", "roger", [100, 89, 100, 83, 79, 71]),
      ch("rayleigh", "Silvers Rayleigh", "rayleigh", [83, 100, 85, 87, 82, 82]),
      ch("gaban", "Scopper Gaban", "gaban", [81, 86, 85, 93, 79, 77]),
      ch("oden", "Kozuki Oden", "oden", [78, 80, 85, 61, 71, 71]),
      ch("crocus", "Crocus", "crocus", [53, 57, 38, 82, 95, 82]),
      ch("nozdon", "Seagull Guns Nozdon", "nozdon", [56, 61, 61, 60, 57, 63]),
      ch("max-marx", "Max Marx", "max-marx", [44, 44, 50, 45, 53, 47]),
      ch("spencer", "Spencer", "spencer", [47, 47, 53, 56, 53, 40]),
      ch("sunbell", "Sunbell", "sunbell", [44, 44, 46, 64, 60, 47]),
      ch("taro", "Taro", "taro", [41, 41, 44, 60, 57, 40]),
      ch("donquino", "Donquino", "donquino", [41, 41, 46, 52, 53, 40]),
      ch("millet-pine", "Millet Pine", "millet-pine", [41, 41, 44, 56, 57, 53]),
      ch("jacksonbanner", "Jacksonbanner", "jacksonbanner", [41, 41, 46, 52, 53, 40]),
      ch("petermoo", "Petermoo", "petermoo", [38, 36, 41, 52, 53, 47]),
      ch("erio", "Erio", "erio", [38, 36, 41, 45, 57, 40]),
      ch("rowing", "Rowing", "rowing", [38, 36, 41, 52, 53, 40]),
      ch("momora", "Mr. Momora", "momora", [29, 36, 41, 64, 60, 34]),
    ],
  },
  {
    id: "rocks",
    name: "Pirati Rocks",
    characters: [
      ch("xebec", "Rocks D. Xebec", "xebec", [96, 78, 98, 78, 44, 77]),
      ch("whitebeard-rocks", "Edward Newgate", "whitebeard", [73, 86, 90, 71, 68, 57], "Era Rocks"),
      ch("bigmom-rocks", "Charlotte Linlin", "bigmom", [71, 74, 82, 61, 50, 61], "Era Rocks"),
      ch("shiki", "Shiki", "shiki", [79, 78, 79, 85, 59, 67]),
      ch("kaido-rocks", "Kaido", "kaido", [59, 68, 70, 41, 23, 24], "Era Rocks"),
      ch("john", "Captain John", "john", [70, 65, 67, 70, 35, 59]),
      ch("wangzhi", "Wang Zhi", "wangzhi", [72, 63, 66, 71, 42, 59]),
      ch("silver-axe", "Silver Axe", "silver-axe", [66, 63, 67, 64, 26, 55]),
      ch("stussy", "Buckingham Stussy", "stussy", [56, 57, 50, 56, 64, 82]),
      ch("gloriosa-rocks", "Gloriosa", "gloriosa", [59, 53, 57, 67, 75, 67], "Era Rocks"),
      ch("streusen-rocks", "Streusen", "streusen", [38, 42, 24, 26, 85, 74], "Era Rocks"),
      ch("ochoku", "Ochoku", "ochoku", [59, 53, 57, 56, 35, 47]),
      ch("ganzui", "Ganzui", "ganzui", [56, 53, 57, 52, 35, 53]),
      ch("marlon", "Don Marlon", "marlon", [59, 53, 57, 56, 35, 53]),
      ch("gill-bastar", "Gill Bastar", "gill-bastar", [56, 53, 57, 56, 35, 47]),
      ch("barbel", "Barbel", "barbel", [53, 47, 53, 56, 35, 47]),
    ],
  },
  {
    id: "whitebeard",
    name: "Pirati di Barbabianca",
    characters: [
      ch("newgate", "Edward Newgate", "whitebeard", [99, 86, 99, 78, 87, 65]),
      ch("marco", "Marco", "marco", [80, 96, 76, 81, 96, 77]),
      ch("ace", "Portgas D. Ace", "ace", [75, 78, 73, 74, 74, 61]),
      ch("jozu", "Jozu", "jozu", [63, 72, 71, 59, 72, 36]),
      ch("vista", "Vista", "vista", [66, 74, 71, 64, 68, 57]),
      ch("thatch", "Thatch", "thatch", [56, 61, 53, 60, 78, 59]),
      ch("izo", "Izo", "izo", [59, 65, 61, 60, 60, 61]),
      ch("oden-wb", "Kozuki Oden", "oden", [74, 76, 82, 56, 68, 67], "Pirati di Barbabianca"),
      ch("blamenco", "Blamenco", "blamenco", [56, 61, 61, 52, 57, 57]),
      ch("rakuyo", "Rakuyo", "rakuyo", [56, 61, 61, 52, 57, 47]),
      ch("namur", "Namur", "namur", [56, 61, 57, 85, 60, 47]),
      ch("blenheim", "Blenheim", "blenheim", [53, 61, 61, 45, 64, 40]),
      ch("curiel", "Curiel", "curiel", [53, 57, 57, 52, 53, 61]),
      ch("atmos", "Atmos", "atmos", [56, 57, 61, 45, 60, 40]),
      ch("kingdew", "Kingdew", "kingdew", [50, 57, 57, 45, 53, 40]),
      ch("haruta", "Haruta", "haruta", [50, 57, 57, 52, 57, 47]),
      ch("speed-jiru", "Speed Jiru", "speed-jiru", [50, 57, 57, 45, 50, 40]),
      ch("fossa", "Fossa", "fossa", [53, 57, 57, 45, 53, 47]),
    ],
  },
  {
    id: "red-hair",
    name: "Pirati del Rosso",
    characters: [
      ch("shanks", "Shanks", "shanks", [98, 86, 97, 85, 82, 74]),
      ch("beckman", "Benn Beckman", "beckman", [83, 98, 82, 86, 80, 87]),
      ch("roux", "Lucky Roux", "roux", [66, 72, 71, 73, 74, 59]),
      ch("yasopp", "Yasopp", "yasopp", [65, 74, 73, 77, 71, 82]),
      ch("limejuice", "Limejuice", "limejuice", [56, 61, 61, 56, 57, 59]),
      ch("building-snake", "Building Snake", "building-snake", [59, 61, 53, 88, 60, 57]),
      ch("hongo", "Hongo", "hongo", [53, 53, 41, 64, 82, 69]),
      ch("howling-gab", "Howling Gab", "howling-gab", [56, 61, 61, 56, 57, 53]),
      ch("bonk-punch", "Bonk Punch", "bonk-punch", [50, 57, 61, 45, 57, 47]),
      ch("monster", "Monster", "monster", [29, 41, 50, 30, 53, 53]),
      ch("rockstar", "Rockstar", "rockstar", [29, 36, 41, 36, 46, 25]),
    ],
  },
  {
    id: "blackbeard",
    name: "Pirati di Barbanera",
    characters: [
      ch("teach", "Marshall D. Teach", "teach", [89, 74, 85, 74, 40, 82]),
      ch("kuzan", "Kuzan", "kuzan", [80, 86, 90, 79, 76, 77]),
      ch("shiryu", "Shiryu", "shiryu", [68, 83, 76, 61, 24, 67]),
      ch("burgess", "Jesus Burgess", "burgess", [62, 69, 71, 36, 63, 28]),
      ch("augur", "Van Augur", "augur", [64, 72, 71, 83, 78, 87]),
      ch("pizarro", "Avalo Pizarro", "pizarro", [68, 65, 67, 67, 42, 64]),
      ch("lafitte", "Lafitte", "lafitte", [59, 68, 61, 90, 60, 69]),
      ch("devon", "Catarina Devon", "devon", [62, 61, 64, 56, 35, 67]),
      ch("sanjuan-wolf", "Sanjuan Wolf", "sanjuan-wolf", [44, 47, 67, 26, 46, 40]),
      ch("vasco-shot", "Vasco Shot", "vasco-shot", [50, 53, 61, 36, 42, 47]),
      ch("docq", "Doc Q", "docq", [44, 42, 53, 32, 87, 79]),
    ],
  },
  {
    id: "beast",
    name: "Pirati delle Cento Bestie",
    characters: [
      ch("kaido", "Kaido", "kaido", [89, 81, 97, 71, 57, 60]),
      ch("king", "King", "king", [73, 89, 79, 79, 69, 65]),
      ch("queen", "Queen", "queen", [65, 71, 71, 60, 76, 95]),
      ch("jack", "Jack", "jack", [63, 69, 68, 61, 62, 28]),
      ch("whoswho", "Who's-Who", "whoswho", [64, 61, 64, 69, 55, 68]),
      ch("black-maria", "Black Maria", "black-maria", [59, 61, 57, 56, 60, 67]),
      ch("sasaki", "Sasaki", "sasaki", [56, 61, 61, 52, 53, 55]),
      ch("drake", "X Drake", "drake", [70, 61, 64, 67, 60, 61]),
      ch("hawkins", "Basil Hawkins", "hawkins", [68, 53, 57, 60, 57, 72]),
      ch("apoo", "Scratchmen Apoo", "apoo", [65, 44, 50, 56, 53, 64]),
      ch("ulti", "Ulti", "ulti", [50, 57, 61, 40, 42, 47]),
      ch("pageone", "Page One", "pageone", [44, 53, 57, 36, 35, 47]),
    ],
  },
  {
    id: "big-mom",
    name: "Pirati di Big Mom",
    characters: [
      ch("linlin", "Charlotte Linlin", "bigmom", [86, 78, 90, 67, 62, 67]),
      ch("katakuri", "Charlotte Katakuri", "katakuri", [81, 96, 82, 79, 82, 79]),
      ch("smoothie", "Charlotte Smoothie", "smoothie", [68, 74, 68, 71, 66, 61]),
      ch("cracker", "Charlotte Cracker", "cracker", [65, 71, 70, 66, 69, 64]),
      ch("perospero", "Charlotte Perospero", "perospero", [72, 78, 66, 74, 74, 79]),
      ch("compote", "Charlotte Compote", "compote", [64, 65, 50, 64, 70, 61]),
      ch("daifuku", "Charlotte Daifuku", "daifuku", [62, 65, 64, 56, 57, 59]),
      ch("oven", "Charlotte Oven", "oven", [64, 68, 67, 60, 60, 57]),
      ch("snack", "Charlotte Snack", "snack", [59, 61, 61, 56, 57, 55]),
      ch("montdor", "Charlotte Mont-d'Or", "montdor", [62, 61, 41, 64, 66, 77]),
      ch("amande", "Charlotte Amande", "amande", [56, 61, 61, 52, 53, 57]),
      ch("pekoms", "Pekoms", "pekoms", [50, 57, 57, 76, 57, 40]),
      ch("tamago", "Tamago", "tamago", [53, 53, 46, 45, 66, 55]),
      ch("streusen", "Streusen", "streusen", [41, 47, 22, 24, 88, 82]),
      ch("brulee", "Charlotte Brûlée", "brulee", [33, 36, 27, 70, 63, 69]),
      ch("pudding", "Charlotte Pudding", "pudding", [38, 41, 24, 52, 68, 74]),
      ch("galette", "Charlotte Galette", "galette", [44, 44, 41, 45, 64, 61]),
    ],
  },
  {
    id: "heart",
    name: "Pirati Heart",
    characters: [
      ch("law", "Trafalgar D. Water Law", "law", [82, 81, 79, 79, 96, 88]),
      ch("bepo", "Bepo", "bepo", [61, 78, 64, 79, 76, 55]),
      ch("jeanbart", "Jean Bart", "jeanbart", [50, 59, 59, 64, 70, 31]),
      ch("penguin", "Penguin", "penguin", [46, 53, 41, 84, 71, 57]),
      ch("shachi", "Shachi", "shachi", [44, 49, 43, 83, 70, 56]),
      ch("ikkaku", "Ikkaku", "ikkaku", [41, 44, 38, 70, 70, 55]),
    ],
  },
  {
    id: "kid",
    name: "Pirati di Kid",
    characters: [
      ch("kid", "Eustass Kid", "kid", [78, 72, 79, 66, 52, 72]),
      ch("killer", "Killer", "killer", [72, 89, 73, 76, 76, 67]),
      ch("heat", "Heat", "heat", [48, 53, 48, 64, 63, 47]),
      ch("wire", "Wire", "wire", [47, 49, 46, 66, 62, 40]),
      ch("dive", "Dive", "dive", [29, 28, 34, 56, 46, 34]),
      ch("mosh", "Mosh", "mosh", [26, 28, 38, 36, 35, 25]),
      ch("quincy", "Quincy", "quincy", [24, 25, 34, 36, 35, 25]),
      ch("disc-j", "Disc J", "disc-j", [24, 23, 30, 45, 46, 40]),
      ch("compo", "Compo", "compo", [22, 21, 30, 40, 46, 31]),
    ],
  },
  {
    id: "donquixote",
    name: "Famiglia Donquixote",
    characters: [
      ch("doflamingo", "Donquixote Doflamingo", "doflamingo", [86, 78, 76, 73, 50, 82]),
      ch("vergo", "Vergo", "vergo", [66, 86, 70, 73, 69, 71]),
      ch("trebol", "Trebol", "trebol", [65, 72, 57, 56, 65, 71]),
      ch("diamante", "Diamante", "diamante", [62, 68, 63, 61, 63, 59]),
      ch("pica", "Pica", "pica", [56, 67, 68, 45, 67, 63]),
      ch("monet", "Monet", "monet", [44, 57, 44, 45, 57, 67]),
      ch("sugar", "Sugar", "sugar", [29, 41, 20, 24, 57, 90]),
      ch("lao-g", "Lao G", "lao-g", [53, 57, 57, 40, 53, 53]),
      ch("senor-pink", "Señor Pink", "senor-pink", [50, 57, 53, 40, 57, 47]),
      ch("machvise", "Machvise", "machvise", [44, 47, 50, 30, 46, 34]),
      ch("dellinger", "Dellinger", "dellinger", [41, 47, 53, 36, 35, 40]),
      ch("gladius", "Gladius", "gladius", [47, 53, 53, 36, 42, 53]),
      ch("buffalo", "Buffalo", "buffalo", [33, 36, 41, 67, 35, 40]),
      ch("baby5", "Baby 5", "baby5", [33, 44, 44, 36, 50, 53]),
      ch("jora", "Giolla", "jora", [26, 28, 31, 30, 46, 59]),
      ch("caesar", "Caesar Clown", "caesar", [56, 36, 41, 40, 66, 96]),
    ],
  },
  {
    id: "cross-guild",
    name: "Cross Guild",
    characters: [
      ch("buggy", "Buggy", "buggy", [81, 28, 22, 74, 70, 74]),
      ch("mihawk", "Dracule Mihawk", "mihawk", [76, 83, 90, 81, 62, 72]),
      ch("crocodile", "Crocodile", "crocodile", [82, 86, 76, 79, 64, 90]),
      ch("daz", "Daz Bonez", "daz", [61, 76, 66, 61, 68, 55]),
      ch("galdino", "Galdino", "galdino", [38, 36, 27, 30, 66, 69]),
      ch("alvida", "Alvida", "alvida", [44, 36, 34, 36, 46, 53]),
      ch("cabaji", "Cabaji", "cabaji", [33, 36, 38, 30, 35, 31]),
      ch("mohji", "Mohji", "mohji", [24, 23, 27, 27, 42, 34]),
      ch("richie", "Richie", "richie", [21, 21, 38, 23, 22, 21]),
    ],
  },
  {
    id: "sun",
    name: "Pirati del Sole",
    characters: [
      ch("tiger", "Fisher Tiger", "tiger", [89, 81, 76, 88, 88, 71]),
      ch("jinbe-sun", "Jinbe", "jinbe", [78, 89, 71, 96, 85, 71], "Pirati del Sole"),
      ch("arlong", "Arlong", "arlong", [70, 69, 61, 86, 48, 51]),
      ch("aladine", "Aladine", "aladine", [68, 78, 57, 86, 89, 69]),
      ch("hatchan", "Hachi", "hatchan", [44, 47, 50, 67, 60, 61]),
      ch("macro", "Macro", "macro", [38, 28, 34, 70, 35, 31]),
      ch("gyaro", "Gyaro", "gyaro", [24, 23, 30, 64, 26, 23]),
      ch("tansui", "Tansui", "tansui", [22, 21, 27, 64, 26, 23]),
    ],
  },
  {
    id: "thriller-bark",
    name: "Thriller Bark",
    characters: [
      ch("moria", "Gecko Moria", "moria", [75, 61, 63, 64, 62, 79]),
      ch("perona", "Perona", "perona", [63, 67, 55, 67, 75, 82]),
      ch("absalom", "Absalom", "absalom", [46, 53, 44, 61, 60, 69]),
      ch("hogback", "Dr. Hogback", "hogback", [39, 41, 21, 27, 89, 90]),
      ch("ryuma", "Ryuma", "ryuma", [38, 53, 68, 23, 20, 40], "Zombie"),
      ch("oars", "Oars", "oars", [20, 36, 73, 21, 20, 20]),
    ],
  },
  {
    id: "grand-fleet",
    name: "Grande Flotta e Alleati di Cappello di Paglia",
    characters: [
      ch("hancock", "Boa Hancock", "hancock", [86, 80, 79, 78, 72, 77]),
      ch("cavendish", "Cavendish", "cavendish", [78, 69, 70, 75, 66, 67]),
      ch("sai", "Sai", "sai", [76, 74, 68, 70, 75, 61]),
      ch("bonney", "Jewelry Bonney", "bonney", [68, 61, 67, 64, 71, 74]),
      ch("bartolomeo", "Bartolomeo", "bartolomeo", [70, 68, 61, 45, 85, 77]),
      ch("orlumbus", "Orlumbus", "orlumbus", [79, 68, 50, 88, 75, 71]),
      ch("ideo", "Ideo", "ideo", [68, 65, 66, 60, 64, 57]),
      ch("leo", "Leo", "leo", [66, 61, 45, 67, 79, 82]),
    ],
  },
  {
    id: "giant-warriors",
    name: "Pirati Guerrieri Giganti",
    characters: [
      ch("dorry", "Dorry", "dorry", [83, 80, 79, 82, 79, 59]),
      ch("brogy", "Brogy", "brogy", [83, 80, 79, 82, 79, 59]),
      ch("oimo", "Oimo", "oimo", [59, 63, 64, 60, 68, 28]),
      ch("kashii", "Kashii", "kashii", [59, 63, 64, 60, 68, 28]),
    ],
  },
  {
    id: "new-giant-warriors",
    name: "Nuovi Pirati Guerrieri Giganti",
    characters: [
      ch("hajrudin", "Hajrudin", "hajrudin", [81, 74, 71, 69, 72, 59]),
      ch("stansen", "Stansen", "stansen", [59, 65, 59, 71, 78, 85]),
      ch("road", "Road", "road", [58, 53, 46, 92, 63, 71]),
      ch("goldberg", "Goldberg", "goldberg", [56, 59, 59, 67, 82, 79]),
      ch("gerd", "Gerd", "gerd", [61, 65, 53, 71, 91, 85]),
    ],
  },
  {
    id: "marines",
    name: "Marina",
    characters: [
      ch("garp", "Monkey D. Garp", "garp", [79, 83, 96, 67, 71, 59]),
      ch("sengoku", "Sengoku", "sengoku", [86, 78, 76, 74, 80, 77]),
      ch("akainu", "Sakazuki", "akainu", [86, 74, 85, 71, 35, 67], "Akainu"),
      ch("aokiji", "Kuzan", "kuzan", [76, 81, 82, 76, 71, 72], "Aokiji"),
      ch("kizaru", "Borsalino", "kizaru", [72, 74, 85, 76, 46, 69], "Kizaru"),
      ch("fujitora", "Issho", "fujitora", [74, 71, 82, 67, 66, 85], "Fujitora"),
      ch("ryokugyu", "Aramaki", "ryokugyu", [68, 68, 76, 64, 53, 67], "Ryokugyu"),
      ch("tsuru", "Tsuru", "tsuru", [74, 71, 61, 74, 80, 76]),
      ch("smoker", "Smoker", "smoker", [70, 68, 64, 67, 64, 63]),
      ch("tashigi", "Tashigi", "tashigi", [50, 57, 57, 52, 64, 53]),
      ch("gion", "Gion", "gion", [66, 68, 67, 64, 60, 63], "Momousagi"),
      ch("tokikake", "Tokikake", "tokikake", [64, 65, 64, 60, 57, 61], "Chaton"),
      ch("koby", "Koby", "koby", [64, 65, 68, 56, 78, 61]),
      ch("momonga", "Momonga", "momonga", [64, 65, 61, 60, 57, 55]),
      ch("onigumo", "Onigumo", "onigumo", [62, 61, 61, 56, 53, 55]),
      ch("doberman", "Doberman", "doberman", [59, 61, 61, 52, 50, 53]),
      ch("strawberry", "Strawberry", "strawberry", [59, 57, 57, 56, 53, 53]),
      ch("yamakaji", "Yamakaji", "yamakaji", [59, 57, 57, 52, 50, 53]),
      ch("bastille", "Bastille", "bastille", [56, 57, 57, 45, 46, 47]),
      ch("t-bone", "T-Bone", "t-bone", [62, 57, 53, 56, 64, 47]),
      ch("hina", "Hina", "hina", [62, 53, 50, 60, 63, 61]),
      ch("dalmatian", "Dalmatian", "dalmatian", [56, 53, 53, 52, 50, 47]),
      ch("stainless", "Stainless", "stainless", [56, 53, 53, 52, 50, 47]),
      ch("maynard", "Maynard", "maynard", [53, 53, 50, 52, 50, 53]),
      ch("bluegrass", "Bluegrass", "bluegrass", [53, 53, 53, 52, 46, 53]),
      ch("grus", "Prince Grus", "grus", [50, 53, 57, 45, 46, 61]),
      ch("kujaku", "Kujaku", "kujaku", [50, 53, 53, 45, 50, 55]),
      ch("doll", "Doll", "doll", [50, 47, 50, 45, 46, 53]),
      ch("hound", "Hound", "hound", [47, 47, 50, 45, 42, 47]),
      ch("guillotine", "Guillotine", "guillotine", [47, 47, 50, 45, 42, 47]),
      ch("red-king", "Red King", "red-king", [47, 47, 50, 45, 42, 47]),
      ch("urban", "Urban", "urban", [47, 47, 50, 45, 42, 47]),
      ch("pomsky", "Pomsky", "pomsky", [44, 44, 46, 45, 42, 47]),
      ch("tosa", "Tosa", "tosa", [44, 44, 46, 45, 42, 47]),
      ch("helmeppo", "Helmeppo", "helmeppo", [41, 57, 44, 45, 57, 40]),
      ch("hibari", "Hibari", "hibari", [33, 36, 32, 45, 63, 53]),
    ],
  },
  {
    id: "world-government",
    name: "Governo Mondiale",
    characters: [
      ch("imu", "Imu", "imu", [83, 53, 76, 40, 26, 87]),
      ch("garling", "Figarland Garling", "garling", [81, 71, 76, 64, 26, 64]),
      ch("nusjuro", "Ethanbaron V. Nusjuro", "nusjuro", [70, 68, 82, 56, 35, 64]),
      ch("warcury", "Topman Warcury", "warcury", [70, 65, 76, 56, 82, 61]),
      ch("mars", "Marcus Mars", "mars", [70, 65, 73, 76, 53, 64]),
      ch("ju-peter", "Shepherd Ju Peter", "ju-peter", [70, 65, 73, 60, 53, 64]),
      ch("shamrock", "Figarland Shamrock", "shamrock", [76, 74, 71, 64, 35, 64]),
      ch("saturn", "Jaygarcia Saturn", "saturn", [70, 61, 68, 45, 53, 77], "Ex Astro di Saggezza"),
      ch("gunko", "Manmayer Gunko", "gunko", [59, 65, 67, 56, 42, 69]),
      ch("sommers", "Shepherd Sommers", "sommers", [56, 61, 64, 52, 35, 64]),
      ch("killingham", "Rimoshifu Killingham", "killingham", [56, 61, 64, 52, 35, 64]),
    ],
  },
  {
    id: "others",
    name: "Altri Personaggi",
    characters: [
      ch("dragon", "Monkey D. Dragon", "dragon", [95, 71, 70, 81, 71, 79]),
      ch("sabo", "Sabo", "sabo", [72, 81, 73, 70, 68, 63]),
      ch("kuma", "Bartholomew Kuma", "kuma", [70, 68, 73, 76, 82, 82]),
      ch("yamato", "Yamato", "yamato", [70, 71, 79, 64, 66, 57]),
      ch("ivankov", "Emporio Ivankov", "ivankov", [72, 53, 67, 64, 85, 72]),
      ch("enel", "Enel", "enel", [72, 47, 73, 67, 21, 77]),
      ch("magellan", "Magellan", "magellan", [70, 65, 70, 36, 42, 72]),
      ch("bege", "Capone Bege", "bege", [79, 53, 57, 67, 64, 77]),
      ch("kyros", "Kyros", "kyros", [66, 71, 73, 45, 60, 40]),
      ch("riku", "King Riku", "riku", [76, 41, 38, 56, 72, 57]),
      ch("vivi", "Nefertari Vivi", "vivi", [70, 36, 22, 56, 68, 64]),
      ch("momonosuke", "Kozuki Momonosuke", "momonosuke", [66, 23, 38, 74, 42, 63]),
      ch("caesar-others", "Caesar Clown", "caesar-others", [56, 36, 41, 40, 66, 96]),
    ],
  },
];

export const CREWS = RAW_CREWS.map((crew) => ({
  ...crew,
  characters: crew.characters.map((c) => ({ ...c, natural: naturalRolesFor(c.id, c.stats) })),
}));
